import React, { useState } from "react";
import {
  FaUserShield,
  FaLock,
  FaUser,
  FaEye,
  FaEyeSlash,
  FaBookOpen,
  FaGamepad,
  FaCalendarAlt,
  FaInfoCircle,
  FaPalette,
  FaPuzzlePiece,
  FaMusic,
  FaChild,
  FaShareAlt,
  FaFacebook,
  FaYoutube,
  FaInstagram,
  FaPlayCircle,
  FaStar,
  FaCheckCircle,
  FaShieldAlt,
  FaGraduationCap,
  FaBus,
  FaLaptop,
  FaTree,
  FaBuilding,
  FaHandHoldingUsd,
  FaUsers,
  FaCreditCard,
  FaTimes,
  FaSignInAlt
} from "react-icons/fa";
import { apiService } from "./services/apiService";
import scannerImg from "./scanner_shivaba.jpg";
import shivabaLogo from "./shivaba-logo.jpg";
import wisdomLogo from "./wisdom-logo.jpg";

import "./styles/Login.css";

function Login({ onLoginSuccess }) {
  // Dynamic Year Calculation
  const currentYear = new Date().getFullYear();
  const nextYear = currentYear + 1;

  // Login Form States
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);

  // Modal State for Login Popup
  const [showLoginModal, setShowLoginModal] = useState(false);

  // Public Hub Tab State (defaulting to academics)
  const [activeTab, setActiveTab] = useState("academics");

  // Dynamic Celebration Events Data
  const celebrationEvents = [
    { date: `21 Jun ${currentYear}`, name: "Fathers Day", tag: "activity", label: "Activity" },
    { date: `25 Jul ${currentYear}`, name: "Aashadhi Ekadashi", tag: "cultural", label: "Cultural Event" },
    { date: `15 Aug ${currentYear}`, name: "Independence Day", tag: "cultural", label: "Cultural Event" },
    { date: `28 Aug ${currentYear}`, name: "Raksha Bandhan", tag: "cultural", label: "Cultural Event" },
    { date: `04 Sep ${currentYear}`, name: "Dahi Handi Celebration", tag: "activity", label: "Activity" },
    { date: `05 Sep ${currentYear}`, name: "Teachers Day", tag: "activity", label: "Activity" },
    { date: `14 Sep ${currentYear}`, name: "Ganesh Chaturthi", tag: "holiday", label: "School Holiday" },
    { date: `25 Sep ${currentYear}`, name: "Anant Chaturthi", tag: "holiday", label: "School Holiday" },
    { date: `02 Oct ${currentYear}`, name: "Ganesh Jayanti", tag: "holiday", label: "School Holiday" },
    { date: `08 Nov ${currentYear}`, name: "Diwali Celebration", tag: "cultural", label: "Cultural Event" },
    { date: `14 Nov ${currentYear}`, name: "Childrens Day", tag: "activity", label: "Activity" },
    { date: `26 Dec ${currentYear}`, name: "Annual Day (Gathering)", tag: "activity", label: "Activity" },
    { date: `01 Jan ${nextYear}`, name: "New Year Celebration", tag: "activity", label: "Activity" },
    { date: `03 Jan ${nextYear}`, name: "Savitribai Phule Jayanti", tag: "activity", label: "Activity" },
    { date: `14 Jan ${nextYear}`, name: "Makar Sankranti", tag: "cultural", label: "Cultural Event" },
    { date: `06 Jan ${nextYear} - 08 Jan ${nextYear}`, name: "Sports Days", tag: "activity", label: "Activity" },
    { date: `26 Jan ${nextYear}`, name: "Republic Day", tag: "cultural", label: "Cultural Event" },
    { date: `19 Feb ${nextYear}`, name: "Shiv Jayanti", tag: "cultural", label: "Cultural Event" },
    { date: `28 Feb ${nextYear}`, name: "Science Day", tag: "activity", label: "Activity" },
    { date: `08 Mar ${nextYear}`, name: "Womens Day", tag: "activity", label: "Activity" }
  ];

  // Wisdom Monthly Colour Data
  const monthlyColours = [
    { month: `JUNE ${currentYear}`, colorName: "RED", hex: "#f44336" },
    { month: `JULY ${currentYear}`, colorName: "YELLOW", hex: "#ffeb3b" },
    { month: `AUGUST ${currentYear}`, colorName: "PINK", hex: "#e91e63" },
    { month: `SEPTEMBER ${currentYear}`, colorName: "GREEN", hex: "#4caf50" },
    { month: `OCTOBER ${currentYear}`, colorName: "WHITE", hex: "#ffffff" },
    { month: `NOVEMBER ${currentYear}`, colorName: "BLACK", hex: "#000000" },
    { month: `DECEMBER ${currentYear}`, colorName: "PURPLE", hex: "#9c27b0" },
    { month: `JANUARY ${nextYear}`, colorName: "ORANGE", hex: "#ff9800" },
    { month: `FEBRUARY ${nextYear}`, colorName: "BLUE", hex: "#2196f3" },
    { month: `MARCH ${nextYear}`, colorName: "GREY", hex: "#9e9e9e" },
    { month: `APRIL ${nextYear}`, colorName: "BROWN", hex: "#795548" }
  ];

  const handleSubmit = (e) => {
    e.preventDefault();
    setErrorMessage("");
    setLoading(true);
    apiService
      .login({ username, password })
      .then((data) => {
        setLoading(false);
        onLoginSuccess(
          data.token,
          data.roleId,
          data.clientName,
          data.clientId
        );
      })
      .catch((err) => {
        setLoading(false);
        setErrorMessage(err.message || "Invalid credentials.");
      });
  };

  return (
    <div className="public-portal-layout full-width-layout" style={{ display: "block", minHeight: "100vh", padding: "20px" }}>
      {/* ================= FULL PAGE CONTENT HUB ================= */}
      <div className="public-content-main" style={{ width: "100%", maxWidth: "1200px", margin: "0 auto" }}>
        
        {/* Header with Wisdom Logo (Left), Title (Center), and Shivaba Logo (Right) + Login Button */}
        <header className="public-hub-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "15px", background: "#ffffff", padding: "20px", borderRadius: "12px", boxShadow: "0 4px 15px rgba(0,0,0,0.05)", marginBottom: "20px" }}>
          
          {/* Left Side: Wisdom Logo */}
          <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
            <img
              src={wisdomLogo}
              alt="Wisdom Logo"
              style={{ width: "75px", height: "75px", objectFit: "contain", borderRadius: "8px", pointerEvents: "none", userSelect: "none" }}
              draggable="false"
              onContextMenu={(e) => e.preventDefault()}
            />
            <div className="hub-brand">
              <div>
                <h1 style={{ fontSize: "22px", color: "#1a237e", margin: "0 0 5px 0" }}>Welcome to Wisdom Preschool Shivajinagar Akole, Cambridge Curriculum Learning</h1>
                <p style={{ margin: "0", color: "#666", fontSize: "14px" }}>Explore free learning resources, interactive activities, and academic updates!</p>
              </div>
            </div>
          </div>

          {/* Right Side: Shivaba Logo & Login Portal Trigger Button */}
          <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
            <button
              onClick={() => setShowLoginModal(true)}
              className="login-trigger-btn"
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                backgroundColor: "#1a237e",
                color: "#ffffff",
                border: "none",
                padding: "10px 20px",
                borderRadius: "8px",
                fontSize: "15px",
                fontWeight: "600",
                cursor: "pointer",
                boxShadow: "0 4px 10px rgba(26, 35, 126, 0.2)",
                transition: "background 0.2s"
              }}
            >
              <FaSignInAlt /> Login to Portal
            </button>

            <img
              src={shivabaLogo}
              alt="Shivaba Logo"
              style={{ width: "75px", height: "75px", objectFit: "contain", borderRadius: "8px", pointerEvents: "none", userSelect: "none" }}
              draggable="false"
              onContextMenu={(e) => e.preventDefault()}
            />
          </div>
        </header>

        {/* Public Navigation Menu */}
        <nav className="public-nav-menu" style={{ display: "flex", flexWrap: "wrap", gap: "8px", marginBottom: "20px" }}>
          <button
            type="button"
            className={`nav-tab-btn ${activeTab === "info" ? "active" : ""}`}
            onClick={() => setActiveTab("info")}
          >
            <FaInfoCircle /> School Information
          </button>
          <button
            type="button"
            className={`nav-tab-btn ${activeTab === "fees" ? "active" : ""}`}
            onClick={() => setActiveTab("fees")}
          >
            <FaHandHoldingUsd /> Fee Payment
          </button>
          <button
            type="button"
            className={`nav-tab-btn ${activeTab === "social" ? "active" : ""}`}
            onClick={() => setActiveTab("social")}
          >
            <FaShareAlt /> Social Connect & Reels
          </button>
          <button
            type="button"
            className={`nav-tab-btn ${activeTab === "calendar" ? "active" : ""}`}
            onClick={() => setActiveTab("calendar")}
          >
            <FaCalendarAlt /> Celebration Calendar
          </button>
          <button
            type="button"
            className={`nav-tab-btn ${activeTab === "colours" ? "active" : ""}`}
            onClick={() => setActiveTab("colours")}
          >
            <FaPalette /> Monthly Colours
          </button>
          <button
            type="button"
            className={`nav-tab-btn ${activeTab === "academics" ? "active" : ""}`}
            onClick={() => setActiveTab("academics")}
          >
            <FaBookOpen /> Academics & Curriculum
          </button>
          <button
            type="button"
            className={`nav-tab-btn ${activeTab === "games" ? "active" : ""}`}
            onClick={() => setActiveTab("games")}
          >
            <FaGamepad /> Learning Games
          </button>
        </nav>

        {/* Public Hub Dynamic Content Container */}
        <div className="public-tab-display" style={{ background: "#ffffff", padding: "25px", borderRadius: "12px", boxShadow: "0 4px 15px rgba(0,0,0,0.05)", minHeight: "400px" }}>
          {/* Tab 1: Academics */}
          {activeTab === "academics" && (
            <div className="tab-pane fade-in">
              <h3>🎨 Early Years Learning Framework</h3>
              <p className="tab-intro">
                Our curriculum focuses on play-based learning, phonics, motor skill expansion, and social adaptability.
              </p>
              <div className="feature-grid">
                <div className="feature-card">
                  <div className="card-icon-circle blue"><FaBookOpen /></div>
                  <h4>Phonics & Storytelling</h4>
                  <p>Interactive letter sounds, puppet stories, and vocabulary building activities for early talkers.</p>
                </div>
                <div className="feature-card">
                  <div className="card-icon-circle green"><FaPalette /></div>
                  <h4>Creative Arts & Crafts</h4>
                  <p>Finger painting, origami, and clay modeling to refine fine motor coordination and expression.</p>
                </div>
                <div className="feature-card">
                  <div className="card-icon-circle orange"><FaPuzzlePiece /></div>
                  <h4>Early Math & Logic</h4>
                  <p>Number matching, spatial pattern recognition, color sorting, and foundational counting.</p>
                </div>
              </div>
            </div>
          )}

          {/* Tab 2: Interactive Games */}
          {activeTab === "games" && (
            <div className="tab-pane fade-in">
              <h3>🎮 Free Learning Activities for Kids</h3>
              <p className="tab-intro">
                Try these fun, interactive mini-games designed to stimulate young minds.
              </p>
              <div className="feature-grid">
                <div className="feature-card game-card">
                  <div className="card-icon-circle purple"><FaPuzzlePiece /></div>
                  <h4>Shape Matcher</h4>
                  <p>Drag and drop geometric shapes to match them with everyday objects.</p>
                  <span className="badge-free">Play Online</span>
                </div>
                <div className="feature-card game-card">
                  <div className="card-icon-circle orange"><FaMusic /></div>
                  <h4>Rhyme Jukebox</h4>
                  <p>Listen and sing along to popular nursery rhymes with animated characters.</p>
                  <span className="badge-free">Listen Now</span>
                </div>
                <div className="feature-card game-card">
                  <div className="card-icon-circle green"><FaPalette /></div>
                  <h4>Color Canvas</h4>
                  <p>Digital coloring pages featuring animals, vehicles, and cartoon friends.</p>
                  <span className="badge-free">Draw Now</span>
                </div>
              </div>
            </div>
          )}

          {/* Tab 3: Fee Payment */}
          {activeTab === "fees" && (
            <div className="tab-pane fade-in">
              <h3><FaCreditCard /> Online Fee Payment Portal</h3>
              <p className="tab-intro">
                Scan the official QR code below using any UPI app (Google Pay, PhonePe, Paytm, BHIM) to securely pay school fees.
              </p>
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "20px" }}>
                <div style={{ background: "#fff", padding: "15px", borderRadius: "12px", boxShadow: "0 4px 15px rgba(0,0,0,0.08)", maxWidth: "320px", textAlign: "center", border: "1px solid #eee" }}>
                  <img
                    src={scannerImg}
                    alt="Fee Payment Scanner"
                    style={{ width: "100%", height: "auto", borderRadius: "8px", pointerEvents: "none", userSelect: "none" }}
                    draggable="false"
                    onContextMenu={(e) => e.preventDefault()}
                  />
                  <p style={{ marginTop: "12px", fontSize: "14px", fontWeight: "600", color: "#1a237e" }}>
                    Wisdom Preschool & Shivaba Fee Scanner
                  </p>
                  <span style={{ fontSize: "12px", color: "#666" }}>Please share transaction screenshot with the office after payment.</span>
                </div>
              </div>
            </div>
          )}

          {/* Tab 4: Social Connect & Reels */}
          {activeTab === "social" && (
            <div className="tab-pane fade-in">
              <h3>📱 Social Connect & Latest Reels</h3>
              <p className="tab-intro">
                Catch up with our latest preschool activities, event highlights, and daily fun uploaded regularly on Facebook & Instagram!
              </p>

              {/* Social Channels Quick Links */}
              <div className="social-links-bar" style={{ display: "flex", gap: "12px", marginBottom: "20px", flexWrap: "wrap" }}>
                <a href="https://www.facebook.com/share/1H9qCnbxuV/" target="_blank" rel="noopener noreferrer" className="social-btn fb">
                  <FaFacebook /> Follow on Facebook
                </a>
                <a href="https://www.instagram.com/wisdom.akole?igsh=YmtwNGlxeXlsMjlu" target="_blank" rel="noopener noreferrer" className="social-btn insta">
                  <FaInstagram /> Follow on Instagram
                </a>
                <a href="https://www.youtube.com/@wisdom.shivajinagar" target="_blank" rel="noopener noreferrer" className="social-btn yt">
                  <FaYoutube /> Subscribe on YouTube
                </a>
              </div>

              {/* Reels Gallery Grid */}
              <div className="reels-grid">
                <div className="reel-card">
                  <div className="reel-thumbnail">
                    <FaPlayCircle className="play-icon" />
                    <span className="reel-tag">Facebook Reel</span>
                  </div>
                  <div className="reel-details">
                    <h4>🎨 Annual Art & Craft Exhibition</h4>
                    <p>Watch our tiny artists present their colorful creations!</p>
                  </div>
                </div>

                <div className="reel-card">
                  <div className="reel-thumbnail">
                    <FaPlayCircle className="play-icon" />
                    <span className="reel-tag">Facebook Reel</span>
                  </div>
                  <div className="reel-details">
                    <h4>🏃 Sports Day Highlights</h4>
                    <p>Fun races, obstacle courses, and pure joy with our little champions.</p>
                  </div>
                </div>

                <div className="reel-card">
                  <div className="reel-thumbnail">
                    <FaPlayCircle className="play-icon" />
                    <span className="reel-tag">Facebook Reel</span>
                  </div>
                  <div className="reel-details">
                    <h4>🎵 Nursery Rhyme & Dance Session</h4>
                    <p>Interactive morning assemblies filled with music and laughter.</p>
                  </div>
                </div>
              </div>

              {/* Testimonials */}
              <div className="testimonials-section" style={{ marginTop: "30px" }}>
                <h4><FaStar color="#ffca28" /> What Parents Say About Us</h4>
                <div className="testimonial-card">
                  <p>"The daily updates and video reels keep us connected with our child's progress. The care and attention given by teachers is exceptional!"</p>
                  <span>- Suvarna Vaidya</span>
                </div>
              </div>
            </div>
          )}

          {/* Tab 5: Celebration Calendar */}
          {activeTab === "calendar" && (
            <div className="tab-pane fade-in">
              <h3>📅 Academic Year {currentYear} - {nextYear} Holiday & Event Schedule</h3>
              <div className="calendar-table-wrapper">
                <table className="calendar-table">
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Occasion / Event</th>
                      <th>Category</th>
                    </tr>
                  </thead>
                  <tbody>
                    {celebrationEvents.map((item, index) => (
                      <tr key={index}>
                        <td>{item.date}</td>
                        <td>{item.name}</td>
                        <td>
                          <span className={`event-tag ${item.tag}`}>{item.label}</span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* Tab 6: Monthly Colours */}
          {activeTab === "colours" && (
            <div className="tab-pane fade-in">
              <h3>🎨 Wisdom Monthly Colour Schedule ({currentYear} - {nextYear})</h3>
              <p className="tab-intro">
                Each month, students celebrate a dedicated color theme through dress code days, art activities, and sensory learning!
              </p>
              <div className="calendar-table-wrapper">
                <table className="calendar-table">
                  <thead>
                    <tr>
                      <th>Month</th>
                      <th>Colour Name</th>
                      <th>Colour Preview</th>
                    </tr>
                  </thead>
                  <tbody>
                    {monthlyColours.map((item, index) => (
                      <tr key={index}>
                        <td><strong>{item.month}</strong></td>
                        <td>{item.colorName}</td>
                        <td>
                          <div
                            style={{
                              backgroundColor: item.hex,
                              width: "60px",
                              height: "28px",
                              borderRadius: "4px",
                              border: item.hex === "#ffffff" ? "1px solid #ccc" : "1px solid rgba(0,0,0,0.1)",
                              margin: "0 auto"
                            }}
                            title={item.colorName}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* Tab 7: School Info */}
          {activeTab === "info" && (
            <div className="tab-pane fade-in">
              <h3>🏫 About Our Preschool & Facilities</h3>
              <p className="tab-intro">
                Providing a safe, nurturing, and technology-enabled learning environment for young learners.
              </p>
              
              {/* General Info Cards */}
              <div className="info-cards-row">
                <div className="info-card">
                  <h4>🔒 Safe & Monitored Campus</h4>
                  <p>24/7 CCTV surveillance with sanitized, child-proofed classroom environments.</p>
                </div>
                <div className="info-card">
                  <h4>👩‍🏫 Certified Educators</h4>
                  <p>Trained teachers specializing in early childhood development and Montessori care.</p>
                </div>
                <div className="info-card">
                  <h4><FaBookOpen className="input-icon" /> CBSE Based Cambridge Curriculum</h4>
                  <p>Modern curriculum designed for holistic child development.</p>
                </div>
                <div className="info-card">
                  <h4><FaPuzzlePiece className="input-icon" /> Cambridge Activity Based Learning</h4>
                  <p>Interactive, play-based learning with hands-on classroom activities.</p>
                </div>
                <div className="info-card">
                  <h4><FaCheckCircle className="input-icon" /> Healthy & Child Friendly Environment</h4>
                  <p>Safe, hygienic and positive atmosphere for every learner.</p>
                </div>
                <div className="info-card">
                  <h4><FaMusic className="input-icon" /> Phonics & Fun Learning</h4>
                  <p>Phonics, alphabets, storytelling and engaging educational activities.</p>
                </div>
                <div className="info-card">
                  <h4><FaPalette className="input-icon" /> Creative Indoor & Outdoor Activities</h4>
                  <p>Art, craft, games, sports and personality development programs.</p>
                </div>
                <div className="info-card">
                  <h4><FaGraduationCap className="input-icon" /> Highly Qualified Teaching Staff</h4>
                  <p>Experienced teachers supported by an efficient school management team.</p>
                </div>
                <div className="info-card">
                  <h4><FaLaptop className="input-icon" /> Computer Learning Lab</h4>
                  <p>Educational software and digital learning resources for children.</p>
                </div>
                <div className="info-card">
                  <h4><FaTree className="input-icon" /> Big Play Area</h4>
                  <p>Spacious playground with age-appropriate play equipment.</p>
                </div>
                <div className="info-card">
                  <h4><FaBuilding className="input-icon" /> Separate Activity Hall</h4>
                  <p>Dedicated hall for dance, music, celebrations and indoor events.</p>
                </div>
                <div className="info-card">
                  <h4><FaHandHoldingUsd className="input-icon" /> Affordable Fee Structure</h4>
                  <p>Quality education with economical and parent-friendly fees.</p>
                </div>
                <div className="info-card">
                  <h4><FaUsers className="input-icon" /> Limited Seats Per Class</h4>
                  <p>Limited class seats ensure individual attention for every child.</p>
                </div>
                <div className="info-card">
                  <h4><FaShieldAlt className="input-icon" /> Excellent Academic Results</h4>
                  <p>Strong academic foundation with proven student performance.</p>
                </div>
                <div className="info-card">
                  <h4><FaShieldAlt className="input-icon" />Access for Online Learning Resources</h4>
                  <p>We are providing Online Learning Platform for Academics Games and activities.</p>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Footer Maintained in Last */}
        <footer className="login-enquiry-footer" style={{ textAlign: "center", marginTop: "30px", padding: "20px", background: "#ffffff", borderRadius: "12px", boxShadow: "0 4px 15px rgba(0,0,0,0.05)" }}>
          <p className="login-enquiry-text" style={{ margin: "0 0 10px 0", color: "#333", fontSize: "14px" }}>
            Enquiry / WhatsApp: <br />
            <span style={{ fontWeight: "600", color: "#1a237e" }}>+91-9881950330 | +91-9730073355</span>
          </p>
          <p className="login-copyright-text" style={{ margin: "0", color: "#777", fontSize: "12px" }}>
            © {currentYear} Softneil Private Limited. <br /> All rights reserved.
          </p>
        </footer>
      </div>

      {/* ================= LOGIN POPUP MODAL ================= */}
      {showLoginModal && (
        <div 
          className="login-modal-overlay"
          onClick={() => setShowLoginModal(false)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
            backdropFilter: "blur(4px)"
          }}
        >
          <div 
            className="login-modal-content"
            onClick={(e) => e.stopPropagation()}
            style={{
              background: "#ffffff",
              padding: "30px",
              borderRadius: "16px",
              width: "100%",
              maxWidth: "400px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
              position: "relative",
              animation: "fadeIn 0.3s ease"
            }}
          >
            {/* Close Button */}
            <button
              onClick={() => setShowLoginModal(false)}
              style={{
                position: "absolute",
                top: "15px",
                right: "15px",
                background: "transparent",
                border: "none",
                fontSize: "18px",
                cursor: "pointer",
                color: "#666"
              }}
            >
              <FaTimes />
            </button>

            <div className="login-header" style={{ textAlign: "center", marginBottom: "20px" }}>
              <div className="login-logo-circle" style={{ margin: "0 auto 10px auto", width: "60px", height: "60px", background: "#f0f2f5", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <FaUserShield size={28} color="#1a237e" />
              </div>
              <h2 style={{ fontSize: "20px", color: "#1a237e", margin: "0 0 5px 0" }}>Wisdom Member Login</h2>
              <p style={{ fontSize: "13px", color: "#666", margin: 0 }}>Access your school management dashboard</p>
            </div>

            <form onSubmit={handleSubmit} className="login-form">
              {errorMessage && <div className="login-error-msg">{errorMessage}</div>}

              <div className="input-group" style={{ marginBottom: "15px" }}>
                <label style={{ display: "block", fontSize: "13px", fontWeight: "600", marginBottom: "5px", color: "#444" }}>
                  <FaUser className="input-icon" /> Username
                </label>
                <input
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder="Enter your username"
                  required
                  style={{ width: "100%", padding: "10px", borderRadius: "8px", border: "1px solid #ccc", fontSize: "14px", boxSizing: "border-box" }}
                />
              </div>

              <div className="input-group" style={{ marginBottom: "20px" }}>
                <label style={{ display: "block", fontSize: "13px", fontWeight: "600", marginBottom: "5px", color: "#444" }}>
                  <FaLock className="input-icon" /> Password
                </label>
                <div className="password-input-wrapper" style={{ position: "relative" }}>
                  <input
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Enter your password"
                    required
                    style={{ width: "100%", padding: "10px", borderRadius: "8px", border: "1px solid #ccc", fontSize: "14px", boxSizing: "border-box" }}
                  />
                  <button
                    type="button"
                    className="password-toggle-btn"
                    onClick={() => setShowPassword(!showPassword)}
                    style={{ position: "absolute", right: "10px", top: "50%", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer", color: "#666" }}
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </button>
                </div>
              </div>

              <button 
                type="submit" 
                disabled={loading || !username.trim() || !password} 
                className="login-submit-btn"
                style={{
                  width: "100%",
                  padding: "12px",
                  backgroundColor: "#1a237e",
                  color: "#fff",
                  border: "none",
                  borderRadius: "8px",
                  fontWeight: "600",
                  fontSize: "15px",
                  cursor: "pointer",
                  opacity: (loading || !username.trim() || !password) ? 0.7 : 1
                }}
              >
                {loading ? "Authenticating..." : "Login to Dashboard"}
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default Login;